import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field } from 'formik';
import { Form, Input, Radio, Checkbox } from 'formik-semantic-ui';
import { Divider } from 'semantic-ui-react';
import Dropzone from 'react-dropzone';
import _ from 'lodash';

import { Button, Box, Flex, Text } from 'src/Components/Base';
import { thaiRegularExpressionWithOutNumber } from 'src/Util/form';
import { COLOR, SPACE } from 'src/Components/Theme';

const FWField = styled(Form.Field)`
  width: 100%;

  /* Override styling error message */
  & .sui-error-message {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const Link = styled(Text)`
  cursor: pointer;
  padding-right: 16px;
  color: ${COLOR.primary};
  text-decoration: underline;
  &:hover {
    color: ${COLOR.primary};
    text-decoration: underline;
  }
`;

const UploadButton = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 25px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const TFTitle = ({ title }) => {
  return (
    <Text is="label" style={{ fontWeight: 500 }}>
      {title}
    </Text>
  );
};

export class ConfirmAdmissionForm extends Component {
  state = {
    userUploadImage: null,
    userUploadImageExceedsMaxAllowedSize: false,
  };

  static propTypes = {
    onSubmit: PropTypes.func,
  };

  static defaultProps = {
    onSubmit: () => {},
  };

  formValidation = values => {
    const errors = {};
    const { firstName, lastName, email, school, isUsedApp, userUploadImage } = values;

    if (firstName === '' || firstName === undefined) {
      errors.firstName = 'กรุณากรอกชื่อของคุณ';
    } else if (!thaiRegularExpressionWithOutNumber.test(firstName)) {
      errors.firstName = 'กรุณากรอกชื่อของคุณเป็นภาษาไทย';
    }

    if (lastName === '' || lastName === undefined) {
      errors.lastName = 'กรุณากรอกนามสกุลของคุณ';
    } else if (!thaiRegularExpressionWithOutNumber.test(lastName)) {
      errors.lastName = 'กรุณากรอกนามสกุลของคุณเป็นภาษาไทย';
    }

    if (email === '' || email === undefined) {
      errors.email = 'กรุณากรอกอีเมลของคุณ';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      errors.email = 'กรุณากรอกอีเมลของคุณให้ถูกต้อง';
    }

    if (school === '' || school === undefined) {
      errors.school = 'กรุณากรอกโรงเรียนของคุณ';
    }

    // BUG: First selected isUsedApp will be empty string ???
    // if (isUsedApp === '' || isUsedApp === undefined) {
    //   console.log(values);
    //   errors.isUsedApp = 'กรุณาเลือก';
    // }

    if (userUploadImage === undefined || userUploadImage.length === 0) {
      errors.userUploadImage = 'กรุณาเลือกรูป';
    }

    return errors;
  };

  handleOnDrop = (acceptedFiles, form) => {
    form.setFieldValue('userUploadImage', acceptedFiles, true);
  };

  handleValidSubmit = (values, formikApi) => {
    this.props.onSubmit(values);
  };

  render() {
    const { isSubmitDisabled, initialValue } = this.props;
    return (
      <Form
        initialValues={{
          firstName: '',
          lastName: '',
          email: '',
          school: '',
          isUsedApp: '',
          acceptTerms: false,
          comment: '',
          ...(initialValue || {}),
        }}
        validate={this.formValidation}
        onSubmit={this.handleValidSubmit}
        validateOnChange
      >
        {props => {
          const { isValid, values } = props;
          const disabledSubmitButton =
            !isValid || values.isUsedApp === '' || isSubmitDisabled || values.acceptTerms === false;
          return (
            <Box style={{ width: '100%' }}>
              <Flex flexDirection="column" mb={SPACE.medium}>
                <Text.Title>ข้อมูลของน้อง</Text.Title>
                <Box mt={SPACE.medium}>
                  <h4>* โปรดกรอกชื่อ - นามสกุลให้ถูกต้อง</h4>
                </Box>
                <Divider />
                <FWField>
                  <TFTitle title="ชื่อ (ภาษาไทย)" />
                  <Input name="firstName" />
                </FWField>
                <FWField>
                  <TFTitle title="นามสกุล (ภาษาไทย)" />
                  <Input name="lastName" />
                </FWField>
                <FWField>
                  <TFTitle title="อีเมล (จะใช้ติดต่อกลับเมื่อได้รับของรางวัล)" />
                  <Input name="email" />
                </FWField>
                <FWField>
                  <TFTitle title="โรงเรียน" />
                  <Input name="school" />
                </FWField>
                <Field
                  name={'userUploadImage'}
                  render={({ field, form }) => {
                    return (
                      <FWField>
                        <TFTitle title="รูปตัวเอง" />
                        <Form.Group style={{ width: '100%', marginLeft: '0px' }}>
                          <Dropzone
                            accept="image/png, image/jpg, image/jpeg"
                            multiple={false}
                            onDrop={acceptedFiles => this.handleOnDrop(acceptedFiles, form)}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <section>
                                <div {...getRootProps()}>
                                  <input {...getInputProps()} />
                                  <UploadButton bg={'primary'} width={'120px'}>
                                    <Text color={'white'} textAlign={'center'}>
                                      Select Image
                                    </Text>
                                  </UploadButton>
                                </div>
                              </section>
                            )}
                          </Dropzone>
                          <input
                            value={_.get(form, ['values', 'userUploadImage', '0', 'path'], '')}
                            style={{ border: 'none' }}
                            readOnly
                          />
                        </Form.Group>
                      </FWField>
                    );
                  }}
                />
                <FWField>
                  <TFTitle title="เคยใช้แอปพลิเคชัน TCASter ไหม?" />
                  <Form.Group>
                    <Radio name="isUsedApp" label="เคย" value={'yes'} />
                    <Radio name="isUsedApp" label="ไม่เคย" value={'no'} />
                  </Form.Group>
                </FWField>
                <FWField>
                  <TFTitle title="อยากฝากอะไรถึงทีมงาน TCASter?" />
                  <Input name="comment" />
                </FWField>
                <FWField>
                  <Checkbox
                    name="acceptTerms"
                    label={{
                      children: (
                        <Fragment>
                          ยอมรับ
                          <Link
                            as="a"
                            href="https://tcaster.net/condition-project/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            เงื่อนไขการเข้าร่วมกิจกรรม
                          </Link>
                        </Fragment>
                      ),
                    }}
                  />
                </FWField>
              </Flex>
              <Box mx="auto" mt={SPACE.medium}>
                <Button
                  primary
                  circular
                  fluid
                  size="medium"
                  type="submit"
                  disabled={disabledSubmitButton}
                  style={{ fontWeight: 500, fontSize: 16 }}
                >
                  สอบติดแล้ว!
                </Button>
              </Box>
            </Box>
          );
        }}
      </Form>
    );
  }
}

export default ConfirmAdmissionForm;
